export enum ButtonsAvailableEnum {
  TELEGRAM_AND_CONSULTATION = 'telegramAndConsultation',
  TELEGRAM = 'telegram',
  CONSULTATION = 'consultation'
}